app.directive('proChart', ['$timeout', '$ionicLoading', 'config', 'ServerTimeService', 'ProChartService', 'LocaleService', 'constants',
    function ($timeout, $ionicLoading, config, ServerTimeService, ProChartService, LocaleService, Const) {
        return {
            scope: {
                asset: '<',
                chart: '<'
            },
            replace: true,
            link: function (scope, element) {
                var objChart,
                    loadTimeout,
                    chartContext = {
                        objChartContext: null,
                        objRequestContext: null,
                        strRequest: null
                    },
                    timeZone = -1 * ServerTimeService.timeZoneOffset * 60,
                    amountBarsShow = 35,
                    historyType = {
                        timestamp: 0,
                        open: 1,
                        high: 2,
                        low: 3,
                        close: 4
                    },
                    chartType = {
                        'line': 'line',
                        'areaspline': 'area',
                        'ohlc': 'line',
                        'candlestick': 'candlesticks'
                    },
                    chartRange = {
                        '1min': '1m',
                        '5min': '5m',
                        '15min': '15m',
                        '30min': '30m',
                        '1hour': '60m',
                        '4hours': '4h',
                        '1day': '1d',
                        '1week': '1w',
                        '1month': '1n'
                    },
                    assetUpdateWatch;

                loadTimeout && $timeout.cancel(loadTimeout);

                var assetSelect = scope.$watch('chart.ready', function (newVal, oldVal) {
                    if (newVal !== oldVal && newVal) {
                        scope.loadingMessage = LocaleService.translation.loading_chart;
                        $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: scope});
                        return objChart ? updateChart() : createChart();
                    }
                });

                function watchPoint() {
                    return scope.$watch('asset.bid', function (newVal, oldValue) {
                        if (newVal && newVal !== oldValue && scope.chart.ready) {
                            updatePoint();
                        }
                    });
                }

                var chartTypeWatch = scope.$watch('chart.type', function (newVal, oldVal) {
                    if (newVal && newVal !== oldVal && scope.chart.ready) {
                        objChart && chartRedrawType(chartType[newVal.type]);
                    }
                });

                var earlyHistoryWatch = scope.$watch('chart.earlyHistory', function (newVal, oldVal) {
                    if (oldVal !== newVal) {
                        if (!oldVal || (oldVal && newVal && (oldVal.request.to !== newVal.request.to))) {
                            if (scope.chart.earlyHistory && scope.chart.earlyHistory.data && scope.chart.earlyHistory.data.length === 0) {
                                console.warn('stop rendering chart history - no more data');
                                objChart.chart.Push(null, {}, 'getearlyhistory', {data: []});
                                scope.stopEarlyHistory = true;
                                return;
                            }

                            var data = convertHistory(scope.chart.earlyHistory.data, true);
                            objChart.chart.Push(null, {}, 'getearlyhistory', data);
                        }
                    }
                })


                function createChart() {
                    console.log('Create new chart instance')
                    objChart = null;
                    var loader = ProChart_Loader()
                    var chartTheme = config['chartTheme'] || 'default';
                    loader.init.loadertemplates = [{"layout": "layout-mobile-indicators", "template": chartTheme}];
                    loader.init.rootpath = config.chartUrl;
                    loader.combinemode = true;
                    loader.LoaderInitComplete = eventLoaderComplete;
                    loader.LoaderInitCombine();
                    loadTimeout = $timeout(function () {
                        if (scope.chart) {
                            scope.chart.loadstate = 'fail';
                        }
                        $ionicLoading.hide();
                        $timeout.cancel(loadTimeout);
                    }, 20000);


                    // objChart = null;
                    // if (!ProChartService.loaded) {
                    //     var prochartloader = ProChartService.getLoader();
                    //     prochartloader.LoaderInitComplete = eventLoaderComplete;
                    //     prochartloader.LoaderInitCombine();
                    //     loadTimeout = $timeout(function () {
                    //         if (scope.chart) {
                    //             scope.chart.loadstate = 'fail';
                    //         }
                    //         $ionicLoading.hide();
                    //         $timeout.cancel(loadTimeout);
                    //     }, 20000);
                    //
                    // } else {
                    //     eventLoaderComplete();
                    // }


                    function eventLoaderComplete() {
                        var chartTheme = config['chartTheme'] || 'default';
                        objChart = ProChart_InitLayout("#chart", "layout-mobile-indicators", chartTheme);
                        objChart.apiinit.rootpath = config.chartUrl;

                        objChart.events.layout.readyComplete = eventlayoutReadyComplete;
                        objChart.events.layout.initComplete = eventlayoutInitComplete;
                        // objChart.gui.init.timeframe = Const.chartTimeFrames;
                        objChart.gui.loadLayout();

                        objChart.events.chart.createComplete = function () {
                            // objChart.gui.fullScreen();
                            objChart.chart.GetNumOfCandles && objChart.chart.SetZoom(objChart.chart.GetNumOfCandles() - amountBarsShow, objChart.chart.GetNumOfCandles(), true);
                        }

                        // objChart.events.chart.onChangeTimeframe = function (parentid, TimeFrameID) {
                        //     console.log('TIMEFRAME REQUEST', parentid, TimeFrameID)
                        //     scope.onChangeTimeframe({timeframe: TimeFrameID})
                        // };
                    }

                    function eventlayoutReadyComplete() {
                        objChart.api.layout.set('width||height', element[0].clientWidth + "||" + element[0].clientHeight);
                        if (scope.chart) {
                            scope.chart.loadstate = 'success';
                        }

                        loadTimeout && $timeout.cancel(loadTimeout);
                    }
                }

                function eventlayoutInitComplete() {
                    objChart.chart.DateFormat = {
                        "realtime": "DD/MM/YYYY HH:mm:ss",
                        "minutes": "HH:mm",
                        "hours": "DD/MM/YYYY HH:mm:ss",
                        "eod": "DD/MM/YYYY",
                        "datebarYear": "YYYY",
                        "datebarMonthDay": "DD/MM",
                        "datebarDay": "DD",
                        "datebarFull": "DD/MM/YYYY",
                        "datebarHoursMinutes": "HH:mm",
                        "datebarMonth": "MM"
                    };

                    objChart.chart.WaterMark = false;
                    objChart.chart.StudiesToLoad = [];
                    objChart.chart.ShowBarData = "true";
                    objChart.chart.hAxis.hPadInPixelsLeft = 10;
                    objChart.chart.vAxis.vPadInPixelsTop = 50;
                    objChart.chart.vAxis.smartRound = false;
                    objChart.chart.vAxis.vMarginPixelsBottom = 0;
                    objChart.chart.vAxis.vMarginPixelsTop = 0;
                    objChart.chart.PriceChartType = chartType[scope.chart.type.type];
                    objChart.chart.Symbol = scope.asset.outputName;
                    objChart.chart.SymbolName = scope.asset.outputName;
                    objChart.chart.TimeScale = chartRange[scope.chart.range.title];
                    objChart.chart.Precision = scope.asset.digits;
                    objChart.chart.TimeZone = timeZone;
                    objChart.chart.BigValuesFormat = null;


                    objChart.chart.JSPush = {
                        enableHistory: true,
                        enableRT: true,
                        enableSymbols: true,
                        enableStudies: true,
                        enableEarlyHistory: true,
                        earlyHistorySize: 200,
                        funcFetchData: getChartData
                    };

                    ProChartService.loaded = true;
                    loadTimeout && $timeout.cancel(loadTimeout);
                }

                function getChartData(objChartContext, objRequestContext, strRequest, objParameters) {
                    switch (strRequest.toLowerCase()) {
                        case "getrecenthistory":
                            var data = convertHistory(scope.chart.data);
                            objChart.chart.Push(objChartContext, objRequestContext, strRequest, data);
                            $ionicLoading.hide();

                            //unsubscribe
                            assetUpdateWatch && assetUpdateWatch();
                            //subscribe
                            assetUpdateWatch = watchPoint();

                            return;
                        case "getmultirt":
                            chartContext = {
                                objChartContext: objChartContext,
                                objRequestContext: objRequestContext,
                                strRequest: strRequest
                            };
                            break;
                        case "getearlyhistory":
                            if (scope.stopEarlyHistory) {
                                //stop chart
                                objChart.chart.Push(null, {}, 'getearlyhistory', {data: []});
                                return;
                            }

                            var firstCandleTimestamp = (scope.chart.earlyHistory && scope.chart.earlyHistory.data && scope.chart.earlyHistory.data.length > 0)
                                ? scope.chart.earlyHistory.data[0][0]
                                : scope.chart.data[0][0];
                            var to = Math.round(firstCandleTimestamp / 1000) - scope.chart.range.timeFrame * 60;
                            var from = to - (scope.chart.range.timeFrame * 60 * 200);

                            scope.$parent.getEarlyHistory({from: from, to: to})

                            break;
                    }
                }

                function convertHistory(data, isEarly) {
                    if (!isEarly) {
                        data[data.length - 1][historyType.close] = scope.asset.markupBid();
                    }

                    return {
                        id: scope.asset.outputName,
                        lastTimeStamp: data[data.length - 1][historyType.timestamp],
                        data: data.map(function (candle) {
                            return {
                                open: candle[historyType.open],
                                close: candle[historyType.close],
                                low: candle[historyType.low],
                                high: candle[historyType.high],
                                other: 0,
                                date: candle[historyType.timestamp]
                            }
                        })
                    }
                }

                function updatePoint() {
                    var time = ServerTimeService.time,
                        data = [{
                            id: scope.asset.outputName,
                            lastTimeStamp: time,
                            data: [{
                                bid: scope.asset.markupBid(),
                                ask: scope.asset.markupAsk(),
                                other: 0,
                                date: time
                            }]
                        }];

                    objChart &&
                    objChart.chart &&
                    objChart.chart.Push(
                        chartContext.objChartContext,
                        chartContext.objRequestContext,
                        chartContext.strRequest,
                        data
                    );
                }

                function chartRedrawType(type) {
                    type && objChart.chart.ChangePriceType(type);
                }

                function chartRedrawRange(range) {
                    scope.stopEarlyHistory = false;
                    objChart && objChart.chart.ChangeTimeScale(range);
                    objChart && objChart.chart.SetZoom(objChart.chart.GetNumOfCandles() - amountBarsShow, objChart.chart.GetNumOfCandles(), true);
                }

                function updateChart() {
                    console.log('UPDATE CHART')
                    scope.stopEarlyHistory = false;
                    objChart && objChart.chart.ChangeSymbol({
                        id: scope.asset.outputName,
                        name: scope.asset.description,
                        precision: scope.asset.digits
                    });
                    chartRedrawRange(chartRange[scope.chart.range.title]);
                }

                element.on('$destroy', function () {
                    loadTimeout && $timeout.cancel(loadTimeout);
                    if (objChart) {
                        try {
                            objChart.chart.StopRTRequests()
                        } catch (e) {
                            console.warn('==>', e)
                        }
                    }
                    assetUpdateWatch && assetUpdateWatch();
                    assetSelect && assetSelect();
                    chartTypeWatch && chartTypeWatch();
                    earlyHistoryWatch && earlyHistoryWatch();

                    window.onresize = null;

                    try {
                        objChart && objChart.chart.CleanUp();
                        document.getElementById('chart').innerHTML = '';
                    } catch (e) {
                        console.warn('chart cleanup failed', e);
                    }

                    objChart = null;
                    scope.asset = null;
                    scope.chart = null;
                })
            },
            template: '<div style="position: relative" class="chart" id="chart"></div>'
        }
    }]);
